<template>
    <div :style="{ backgroundColor: data.backgroundColor || '#f9fafb', border: data.hasRedLine ? '2px solid red' : `${data.borderWidth || 1}px solid ${data.borderColor || '#e5e7eb'}`, borderRadius: '8px', padding: '24px', marginBottom: '20px' }">
        <h2 :style="{ margin: '0 0 16px 0', color: data.titleColor || '#111827', fontSize: '24px', fontWeight: 'bold' }" v-html="processRedMarkersForPreview(data.title)"></h2>
        <p :style="{ margin: '0 0 16px 0', color: data.textColor || '#374151', lineHeight: '1.6' }" v-html="processRedMarkersForPreview(data.content)"></p>
    </div>
</template>

<script>
import { processRedMarkersForPreview } from './redMarkHelpers';

export default {
    name: 'TextBlock',
    props: {
        data: {
            type: Object,
            default: () => ({})
        }
    },
    methods: {
        processRedMarkersForPreview(text) {
            const result = processRedMarkersForPreview(text);
            return result.replace(/\n/g, '<br>');
        },
        processRedMarkers(text) {
            if (!text) return '';
            return text.replace(/\[RED\](.*?)\[\/RED\]/g, '<span @if($show_clues)="" style="border: solid red 2px;" @endif="">$1</span>');
        },
        generateHTML() {
            let processedContent = this.data.content || '';
            processedContent = this.processRedMarkers(processedContent);
            processedContent = processedContent.replace(/\n/g, '<br>');
            
            const bgColor = this.data.backgroundColor || '#f9fafb';
            const borderColor = this.data.borderColor || '#e5e7eb';
            const borderWidth = this.data.borderWidth || 1;
            
            let borderStyle = '';
            if (this.data.hasRedLine) {
                borderStyle = `@if($show_clues) border: solid red 2px; @else border: ${borderWidth}px solid ${borderColor}; @endif`;
            } else {
                borderStyle = `border: ${borderWidth}px solid ${borderColor};`;
            }
            
            const styleAttr = this.data.hasRedLine
                ? `@if($show_clues) style="background-color: ${bgColor}; border: solid red 2px; padding: 24px; margin-bottom: 20px;" @else style="background-color: ${bgColor}; border: ${borderWidth}px solid ${borderColor}; padding: 24px; margin-bottom: 20px;" @endif`
                : `style="background-color: ${bgColor}; border: ${borderWidth}px solid ${borderColor}; padding: 24px; margin-bottom: 20px;"`;
            
            return `
                <table width="100%" border="0" cellspacing="0" cellpadding="0" ${styleAttr} bgcolor="${bgColor}">
                    <tr>
                        <td>
                            <table width="100%" border="0" cellspacing="0" cellpadding="0">
                                <tr>
                                    <td style="font-family: Arial, sans-serif; margin: 0 0 16px 0; color: ${this.data.titleColor || '#111827'}; font-size: 24px; font-weight: bold; line-height: 28px;">
                                        ${this.processRedMarkers(this.data.title || '')}
                                    </td>
                                </tr>
                                <tr>
                                    <td style="font-family: Arial, sans-serif; margin: 0 0 16px 0; color: ${this.data.textColor || '#374151'}; font-size: 14px; line-height: 21px;">
                                        ${processedContent}
                                    </td>
                                </tr>
                            </table>
                        </td>
                    </tr>
                </table>
            `;
        },
        getDefaultData() {
            return {
                title: 'Hoofdtitel',
                content: 'Hier komt de tekst van je email. Dit is waar je je belangrijkste boodschap kunt plaatsen.',
                titleColor: '#111827',
                textColor: '#374151',
                backgroundColor: '#f9fafb',
                borderColor: '#e5e7eb',
                borderWidth: 1,
                hasRedLine: false
            };
        }
    }
}
</script>